import { render, staticRenderFns } from "./updateMatiere.vue?vue&type=template&id=a8218caa&"
import script from "./updateMatiere.vue?vue&type=script&lang=js&"
export * from "./updateMatiere.vue?vue&type=script&lang=js&"
import style0 from "./updateMatiere.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports